export default __webpack_public_path__ + "static/media/help1.0f665567.webp";